export default __webpack_public_path__ + "assets/images/1863832279fbbcfc7269779bc188350e.svg";